import { EventEmitter2 } from "eventemitter2";
import { mergeMap } from "rxjs/operators";

import { actionCreators } from "../../actions";
import { Epic } from "../../utils/types";

export class MediaViewerStore extends EventEmitter2 {
    private _mediaViewerVisible = false;
    get mediaViewerVisible() {
        return this._mediaViewerVisible;
    }

    private _id: string | undefined;
    get id() {
        return this._id;
    }

    private _contentUrl: string | undefined;
    get contentUrl() {
        return this._contentUrl;
    }

    private _viewerUrl: string | undefined;
    get viewerUrl() {
        return this._viewerUrl;
    }

    private _height: number | undefined;
    get height() {
        return this._height || 0;
    }

    private _width: number | undefined;
    get width() {
        return this._width || 0;
    }

    private _filename: string | undefined;
    get filename() {
        return this._filename;
    }

    private _size: number | undefined;
    get size() {
        return this._size;
    }

    private _type: string | undefined;
    get type() {
        return this._type;
    }

    public epic: Epic = action$ =>
        action$.pipe(
            mergeMap(action => {
                if (action.type === actionCreators.ToggleMediaViewerVisible.type) {
                    this._mediaViewerVisible = !this._mediaViewerVisible;
                    this.emit("changed");
                } else if (action.type === actionCreators.SetMediaViewerContent.type) {
                    this.clear();

                    const { id, contentUrl, viewerUrl, uploadData } = action.payload;
                    this._id = id;
                    this._contentUrl = contentUrl;
                    this._viewerUrl = viewerUrl;

                    const meta = uploadData && uploadData.meta;

                    if (uploadData) {
                        this._filename = uploadData.filename;
                        this._size = uploadData.size;
                        this._type = uploadData.type;
                    }

                    if (uploadData && meta && meta.original_height && meta.original_width) {
                        this._height = meta.original_height;
                        this._width = meta.original_width;
                    }

                    this.emit("changed");
                }
                return [];
            })
        );

    private clear() {
        this._id = undefined;
        this._contentUrl = undefined;
        this._viewerUrl = undefined;
        this._height = undefined;
        this._width = undefined;
        this._filename = undefined;
        this._size = undefined;
        this._type = undefined;
    }
}
